module.exports = __webpack_public_path__ + "@/assets/img/inscripcion-materias.fac03f24.svg";